export const styles = {
  chatHistoryDrawer: {
    width: '300px',
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'auto',
  },
};
